import React, { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import apiClient, { formatApiError } from '../utils/api';
import { toast } from 'sonner';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';

const ResetPassword = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get('token') || '';
  const [pw, setPw] = useState('');
  const [pw2, setPw2] = useState('');
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (pw.length < 6) { toast.error('Password must be at least 6 characters'); return; }
    if (pw !== pw2) { toast.error('Passwords do not match'); return; }
    setLoading(true);
    try {
      await apiClient.post('/auth/reset-password', { token, new_password: pw });
      setDone(true);
      toast.success('Password reset. You can now log in.');
    } catch (error) {
      toast.error(formatApiError(error));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#f5f0e8] flex items-center justify-center p-4" data-testid="reset-password-page">
      <div className="max-w-md w-full bg-white border border-[#c5d4c8] rounded-xl p-8 shadow-sm">
        <h1 className="text-2xl font-bold text-[#2d2a26] mb-1">Choose a new password</h1>
        <p className="text-sm text-[#6b665c] font-mono mb-6">Must be at least 6 characters.</p>

        {!token ? (
          <div className="bg-red-50 border border-red-200 text-red-800 rounded p-4 text-sm" data-testid="reset-missing-token">
            Reset token missing. Please request a new reset link from the Forgot Password page.
          </div>
        ) : done ? (
          <div className="space-y-4" data-testid="reset-password-done">
            <div className="bg-green-50 border border-green-200 text-green-800 rounded p-4 text-sm">
              Password reset. You can now log in with your new password.
            </div>
            <Button onClick={() => navigate('/login')} className="w-full bg-blue-600 hover:bg-blue-700 text-white" data-testid="go-login-btn">
              Go to login
            </Button>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4" data-testid="reset-password-form">
            <div>
              <Label className="font-mono text-xs uppercase tracking-wider text-[#5a6e5f]">New password</Label>
              <Input type="password" value={pw} onChange={(e) => setPw(e.target.value)} required minLength={6}
                className="mt-2 bg-[#f5f0e8] border-[#c5d4c8] text-[#2d2a26]" data-testid="new-password-input" />
            </div>
            <div>
              <Label className="font-mono text-xs uppercase tracking-wider text-[#5a6e5f]">Confirm password</Label>
              <Input type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} required minLength={6}
                className="mt-2 bg-[#f5f0e8] border-[#c5d4c8] text-[#2d2a26]" data-testid="confirm-password-input" />
            </div>
            <Button type="submit" disabled={loading} className="w-full bg-blue-600 hover:bg-blue-700 text-white" data-testid="reset-submit-btn">
              {loading ? 'Resetting…' : 'Reset password'}
            </Button>
          </form>
        )}
      </div>
    </div>
  );
};

export default ResetPassword;
